const soundCache: Record<string, HTMLAudioElement> = {};

export function preloadSound(src: string): void {
  if (!soundCache[src]) {
    const audio = new Audio(src);
    audio.preload = "auto";
    soundCache[src] = audio;
  }
}

export function playSound(src: string, volume = 0.6): void {
  try {
    const audio = soundCache[src] ?? new Audio(src);
    audio.volume = volume;
    audio.currentTime = 0;
    void audio.play();
  } catch {
    // ignore autoplay restriction errors silently
  }
}
